<script lang="ts">
import { defineComponent } from 'vue';
import { getIconAlias } from '@/utils/transform';
import IconSports from '@/helpers/icon-pack-sports.vue';
import { useFavoritesStore } from '@/stores/favorites';
import { mapActions, mapState } from 'pinia';
import { formatDate } from '@/utils/format';

export default defineComponent({
  name: 'popular-fixtures',
  components: { IconSports },
  computed: {
    ...mapState(useFavoritesStore, ['popularFixturesLoading'])
  },
  methods: {
    ...mapActions(useFavoritesStore, ['deletePopularFixture']),
    getIconAlias,
    formatDate,
  },
  props: ['fixtures'],
});
</script>

<template>
  <section class="relative mx-3">
    <div v-if="popularFixturesLoading" class="table-loader">
      <i class="pi pi-spinner animate-spin text-gray-200" style="font-size: 5em" />
    </div>
    <table class="basic-table">
      <thead>
        <tr>
          <th style="width: 80px">ID</th>
          <th style="width: 35px"></th>
          <th>Матч</th>
          <th style="width: 120px">Начало</th>
          <th style="width: 300px">Турнир</th>
          <th style="width: 200px">Регион</th>
          <th style="width: 80px">Действия</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="fixture in fixtures" v-key="competition.Id">
          <tr>
            <td>{{ fixture.id }}</td>
            <td class="text-center">
              <IconSports :id="getIconAlias(fixture.sport_id)" :height="20" :width="20" />
            </td>
            <td style="text-align: left">
              <span
                v-if="fixture.event_status_type === 'Inprogress'"
                class="text-white bg-red-500 rounded left-2 mr-1 px-1 py-0.5"
                >live</span
              >
              {{ fixture.name }}
            </td>
            <td>
              {{ formatDate(fixture.start_time_utc, 'DD.MM.YYYY') }}
              <span class="text-gray-500">{{ formatDate(fixture.start_time_utc, 'HH:mm') }}</span>
            </td>
            <td>{{ fixture.competition_name }}</td>
            <td>{{ fixture.region_name }}</td>
            <td>
              <div class="cursor-pointer" title="Удалить" @click="deletePopularFixture(fixture.id)">
                <i class="pi pi-times text-red-500"></i>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </section>
</template>

<style scoped lang="scss"></style>
